import React from "react";
import { Reveal } from "./motion";

export default function About({ profile }) {
  const chapters = profile?.manifesto || [];
  return (
    <section id="about" data-testid="about-section" className="relative mx-auto max-w-[1400px] px-6 md:px-10 py-28 md:py-40">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <span className="font-mono text-xs uppercase tracking-[0.28em] text-[#7a7a7a]">/ 01 — My Story</span>
              <h2 className="font-serif text-5xl md:text-6xl tracking-tighter text-[#FAFAFA] mt-6 leading-[0.9]">
                A mind split<br />between the{" "}
                <span className="italic font-light text-[#bdbdbd]">ledger</span> and the{" "}
                <span className="italic font-light text-[#bdbdbd]">lyric</span>.
              </h2>
              <p className="text-[#9a9a9a] mt-8 leading-relaxed max-w-sm">
                I build in the world of technology and finance, and I write to understand the human one.
                This is where I come from, what I do, and how I think.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="lg:col-span-8">
          <div className="border-t border-[#1c1c1c]">
            {chapters.map((c, i) => (
              <Reveal key={c.no} delay={i * 0.05}>
                <div
                  className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-8 py-10 border-b border-[#1c1c1c]"
                  data-testid={`manifesto-${c.no}`}
                >
                  <div className="md:col-span-2 flex items-start">
                    <span className="font-serif text-3xl text-[#3f3f3f] group-hover:text-[#FAFAFA] transition-colors duration-500">
                      {c.no}
                    </span>
                  </div>
                  <div className="md:col-span-10">
                    <h3 className="font-serif text-2xl md:text-3xl tracking-tight text-[#FAFAFA] mb-3">
                      {c.title}
                    </h3>
                    <p className="text-[#a8a8a8] text-lg leading-relaxed">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
